<template>
  <ValidationObserver
    ref="form"
    v-slot="{ invalid }"
    tag="form"
    type="form"
    @submit.prevent="handleForm"
  >
    <modal
      v-model="modalOpened"
      :title="$t('password_reset.password_reset')"
      cancel-text=" "
      ok-text=" "
    >
      <div class="row">
        <div class="col-xs-12">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('login.username').toLowerCase()"
          >
            <div
              class="form-group"
              :class="{'has-error': errors.length}"
            >
              <label for="resetPasswordUsername">{{ $t('login.username') }}</label>
              <input
                id="resetPasswordUsername"
                ref="username"
                v-model="username"
                autocomplete="username"
                class="form-control"
                name="username"
                :placeholder="$t('login.username')"
                type="text"
                :aria-label="$t('login.username')"
              >
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div slot="footer">
        <button
          id="resetPasswordBtn"
          class="btn btn-primary"
          type="submit"
          style="float: left;"
          :disabled="formLocked || username === ''"
        >
          {{ $t('password_reset.send_reset_link') }}
        </button>
        <button
          id="closeResetPasswordModalBtn"
          class="btn btn-info"
          type="reset"
          @click="modalOpened=false"
        >
          {{ $t('uiv.modal.close') }}
        </button>
      </div>
    </modal>
  </ValidationObserver>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {Modal} from 'uiv'
import PortalBackend from '@/api/PortalBackendService'
import json from '@/configuration.json'

export default {
  name: 'PasswordReset',
  components: {Modal, ValidationObserver, ValidationProvider},
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      modalOpened: false,
      username: null,
      formLocked: false
    }
  },
  watch: {
    modalOpened(newValue) {
      this.$emit('input', newValue)
      if(newValue) {
        this.username = ''
        setTimeout(() => {
          this.$refs.username.focus()
        }, 300)
      }
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.modalOpened = newValue
      }
    }
  },

  methods: {
    async handleForm() {
      if (this.username) {
        this.formLocked = true

        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          this.formLocked = false
          return
        }

        PortalBackend.resetPassword(this.username.toLowerCase())
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('password_reset.reset_link_sent_notify_title'),
              content: this.$t('password_reset.reset_link_sent_notify_content'),
              duration: json.notification_duration.success,
              html: true
            })
            // this.$router.push('/login')
            this.username = ''
            this.modalOpened = false
          })
          .catch(data => {
            let notifyData = {
              type: 'danger',
              title: this.$t('password_reset.reset_link_sent_error_notify_title'),
              duration: json.notification_duration.error,
              html: true
            }

            switch(data.error) {
              case 'USER_ANONYMIZED':
              case 'USER_DELETED':
              case 'USER_IS_SERVICE':
              case 'USER_NOT_IN_VALID_DOMAIN':
                notifyData['content'] = this.$t('password_reset.reset_link_sent_no_valid_username_notify_content')
                break
              case 'USER_NOT_ACTIVE':
                notifyData['content'] = this.$t('password_reset.reset_link_sent_user_not_active_notify_content')
                break
              case 'USER_LOCKED':
                notifyData['content'] = this.$t('password_reset.reset_link_sent_user_locked_notify_content')
                break
              case 'USER_ACCOUNT_EXPIRED':
                notifyData['content'] = this.$t('password_reset.reset_link_sent_user_account_expired_notify_content')
                break
              default:
                notifyData['content'] = this.$t('password_reset.reset_link_sent_error_notify_content')
            }

            this.$notify(notifyData)
          })
          .finally(() => this.formLocked = false)
      }
    }
  }
}
</script>
